import { takeLatest } from 'redux-saga/effects';
import {
    getVendorListSuccess,
    getVendorListFail,
    getVendorDetailsSuccess,
    getVendorDetailsFail
} from './vendorState';

import createCrudService from '../../services/crudservice';

import {
    doCrudCall,
    SAVING_MSG,
    UPDATING_MSG,
    DELETING_MSG,
    LOADING_MSG,
    createRecordSuccess,
    updateRecordSuccess,
    deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/system/vendors');

const redirectData = {
    route: '/console/vendors',
    mode: 'list',
    recordId: 0
};

const modelName = 'Vendor';
const modelId = 'vdr_id';


function* getVendorList(data) {
    yield doCrudCall(
        () => crudService.getList(data.payload),
        getVendorListSuccess,
        getVendorListFail,
        null,
        null,
        LOADING_MSG
    );
}


function* getVendorDetails(data) {
    yield doCrudCall(
        () => crudService.getDetails(data.payload),
        getVendorDetailsSuccess,
        getVendorDetailsFail,
        null,
        null,
        LOADING_MSG
    );
}


function* doVendorCreate(data) {
    yield doCrudCall(
        () => crudService.doCreate(data.payload),
        getVendorDetailsSuccess,
        getVendorDetailsFail,
        createRecordSuccess(modelName),
        { ...redirectData, mode: 'reload' },
        SAVING_MSG
    );
}


function* doVendorUpdate(data) {
    yield doCrudCall(
        () => crudService.doUpdate(
            data.payload[modelId],
            data.payload
        ),
        getVendorDetailsSuccess,
        getVendorDetailsFail,
        updateRecordSuccess(modelName),
        { ...redirectData, mode: 'reload' },
        UPDATING_MSG
    );
}


function* doVendorDelete(data) {
    yield doCrudCall(
        () => crudService.doDelete(data.payload.recordId),
        getVendorDetailsSuccess,
        getVendorDetailsFail,
        deleteRecordSuccess(modelName),
        { ...redirectData, mode: data.payload.mode },
        DELETING_MSG
    );
}


function* vendorSaga() {
    yield takeLatest('vendor/getVendorList', getVendorList);
    yield takeLatest('vendor/getVendorDetails', getVendorDetails);
    yield takeLatest('vendor/doVendorCreate', doVendorCreate);
    yield takeLatest('vendor/doVendorUpdate', doVendorUpdate);
    yield takeLatest('vendor/doVendorDelete', doVendorDelete);
}

export default vendorSaga;